import {mixins} from "../app/mixin";

mixins.push(
  {
    el: '#header',
    data() {
      return {
        isScrolled: false,
        isLangDropdownOpen: false,
        isHamburgerMenuOpen: false,
        _hashRetryTimer: null,
        _hashRetryCount: 0,
      }
    },
    mounted() {
      document.addEventListener('click', this.closeLangDropdown, true);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.handleScroll();

      // On initial load: if URL has a localized alias hash (e.g., #urunler / #cozumler), scroll to the correct section
      this.tryScrollToAliasFromHash();
      
      window.addEventListener('hashchange', this.tryScrollToAliasFromHash, { passive: true });
    },
    beforeDestroy() {
      window.removeEventListener('hashchange', this.tryScrollToAliasFromHash, { passive: true });
      if (this._hashRetryTimer) clearTimeout(this._hashRetryTimer);
      window.removeEventListener('scroll', this.handleScroll, { passive: true });
      document.removeEventListener('click', this.closeLangDropdown, true);
    },
    methods: {
      handleScroll() {
        const y = window.scrollY ?? window.pageYOffset ?? document.documentElement.scrollTop ?? 0;
        this.isScrolled = y > 0;
      },
      toggleHamburgerMenu() {
        this.isHamburgerMenuOpen = !this.isHamburgerMenuOpen;
        if (this.isHamburgerMenuOpen) this.isLangDropdownOpen = false;
      },
      toggleLangDropdown() {
        this.isLangDropdownOpen = !this.isLangDropdownOpen;
      },
      
      handleLangItemClick() {
        this.isLangDropdownOpen = false;
        this.isHamburgerMenuOpen = false;
      },
      
      onNavAnchorClick(e) {
        const link = e.currentTarget;
        
        const url = new URL(link.getAttribute('href'), window.location.origin);
        const aliasHash = (url.hash || '').toLowerCase(); // #urunler / #cozumler / #products / #solutions
        const linkPath = url.pathname || '/';
        const currentPath = window.location.pathname || '/';
        
        // 1) Aynı sayfanın içindeysek: sadece scroll yap
        if (linkPath === currentPath) {
          if (aliasHash) {
            history.pushState(null, '', aliasHash);
            this.scrollToAlias(aliasHash);
          }
          
          this.isHamburgerMenuOpen = false;
          this.isLangDropdownOpen = false;
          return;
        }
        
        // 2) Farklı sayfaysa: sayfa yönlendirme
        window.location.href = url.toString();
      },

      // Map alias hashes (#urunler/#cozumler/#products/#solutions) to real IDs and scroll
      scrollToAlias(aliasHash) {
        const map = {
          '#urunler': 'products',
          '#cozumler': 'solutions',
          
          '#products': 'products',
          '#solutions': 'solutions',
        };
        const targetId = map[aliasHash];
        if (!targetId) return;
        
        const headerOffset = 72; // fixed header height
        const el = document.getElementById(targetId);
        if (!el) return;
        
        const rect = el.getBoundingClientRect();
        const absoluteTop = rect.top + window.pageYOffset;
        const y = Math.max(absoluteTop - headerOffset, 0);
        try {
          window.scrollTo({ top: y, behavior: 'smooth' });
        } catch {
          window.scrollTo(0, y);
        }
      },
      
      tryScrollToAliasFromHash() {
        const aliasHash = (window.location.hash || '').toLowerCase();
        if (!aliasHash) return;
        
        const existsNow = this.scrollIfExists(aliasHash);
        if (existsNow) {
          this._hashRetryCount = 0;
          return;
        }
        
        if (this._hashRetryCount < 20) {
          this._hashRetryCount += 1;
          if (this._hashRetryTimer) clearTimeout(this._hashRetryTimer);
          this._hashRetryTimer = setTimeout(() => this.tryScrollToAliasFromHash(), 50);
        } else {
          this._hashRetryCount = 0;
        }
      },
      
      scrollIfExists(aliasHash) {
        const map = {
          '#urunler': 'products',
          '#cozumler': 'solutions',
          '#products': 'products',
          '#solutions': 'solutions',
        };
        const id = map[aliasHash];
        if (!id) return false;
        const el = document.getElementById(id);
        if (!el) return false;
        
        // If found: scroll and close menu
        this.scrollToAlias(aliasHash);
        this.isHamburgerMenuOpen = false;
        this.isLangDropdownOpen = false;
        return true;
      },
      
      
      closeLangDropdown(e) {
        const dropdowns = document.querySelectorAll(".lang-dropdown");
        const triggers = [
          document.querySelector("#changeLangBtn"),
          document.querySelector("#changeLangBtnMobile"),
        ];
        
        const isClickInside = [...dropdowns, ...triggers].some((el) => el?.contains(e.target));
        if (!isClickInside) this.isLangDropdownOpen = false;
      },
    }
  }
);
